import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m95natja9m: FaireBrandEntity = {
  token: "b_m95natja9m",
  type: "brand",
  name: "Aapparella",
  avatarUrl:
    "https://cdn.faire.com/fastly/f80fe527d040b480a4b0bf402257d1f671716ceb1d4cffaf60f793f2e9a27f8b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8e75b75a253defb7b8ff27a66d790a41252f4e9452945dcb3611ff67b07ebbbf.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f80fe527d040b480a4b0bf402257d1f671716ceb1d4cffaf60f793f2e9a27f8b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8e75b75a253defb7b8ff27a66d790a41252f4e9452945dcb3611ff67b07ebbbf.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 110,
  rating: 4.8,
  reviewCount: 808,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Aapparella!  Aapparella is here to support your business with on-trend, high-quality fashion styles at competitive wholesale prices. With many years expeirence in Apparel Wholesale,  we have established strong relationships with trusted manufacturers and suppliers to make sure the high capicity and fast restock.  To make you happy and easy shopping, we will do our absolute best to help you, any question about styles/orders, pls contact us freely. Looking forward to a successful and fashionable journey with you!!\n\n🌻 More Details: \n* 10-20 New arrivals Daily\n* Diverse Product Range: Apparel & Footwear & Accessories  \n* Ship from CA / NY, US ( Ship from oversea factory for urgent orders )\n* 👕Tag : Only Care Label per piece on the inside of the garments, pls find the size on the care label!! \n🌻 *Return Policy \n-All returns must be made to FAIRE within 3 days.\n-All return request must have images of damages or issues.\n-All items returned must have original packaging with full qty.\n-All returns without damages request a 20% restocking fee.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:09.547Z",
    importedBy: "entity-db-cli",
  },
};
